import { render } from "./List.vue?vue&type=template&id=02d977b2&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d977b2"]])

export default __exports__